import React, { useEffect } from 'react';
import publisherlogo from "../assets/publisher-logo.png";
import gamelogo from "../assets/game-logo.png";
import congratsGif from '../assets/congrats.gif';
import { useLanguage } from '../contexts/LanguageContext';
import { trackProgress } from '../utils/progressApi';
import { getConfig } from '../config/gameConfig';

export const Complete = ({ userName, earned, handlePlayAgain, questionSet, totalQuestions, correctAnswers }) => {
    const { language } = useLanguage();
    const isPerfectRun = correctAnswers === totalQuestions;
    
    // Track game completion on mount
    useEffect(() => {
        const trackCompletion = async () => {
            if (getConfig('debugMode')) {
                console.log('Complete component mounted, tracking completion...', {
                    userName,
                    questionSet,
                    totalQuestions,
                    correctAnswers,
                    isPerfectRun
                });
            }
            
            try {
                const notes = isPerfectRun 
                    ? `Απάντησε ${correctAnswers} ερωτήσεις από ${totalQuestions} (Τέλεια επίδοση!)`
                    : `Απάντησε ${correctAnswers} ερωτήσεις από ${totalQuestions}`;
                    
                const result = await trackProgress({
                    username: userName,
                    questionset: questionSet,
                    action: 'complete',
                    notes: notes
                });
                
                if (getConfig('debugMode')) {
                    console.log('Completion tracking result:', result);
                }
            } catch (error) {
                console.error('Failed to track completion:', error);
            }
        };
        
        if (userName && questionSet) {
            trackCompletion();
        } else {
            if (getConfig('debugMode')) {
                console.warn('Complete component: Missing required data', { userName, questionSet });
            }
        }
    }, [userName, questionSet, correctAnswers, totalQuestions, isPerfectRun]);
    
    return (
        <div className="start" style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', backgroundImage: `url(${congratsGif})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="logo-bar">
                <img src={publisherlogo} alt={language.altText.publisherLogo} className="logo-left" />
                <img src={gamelogo} alt={language.altText.gameLogo} className="logo-right" />
            </div>
            <div className="content" style={{ zIndex: 1 }}>
                <div className="dialog">
                    {isPerfectRun ? (
                        <>
                            <h1 className='endText'>{language.complete.perfectCongratulations}</h1>
                            
                            <h3 className="millionText" style={{ marginTop: '20px' }}>{userName.toUpperCase()}, {language.complete.youAre} <span className='millionTextBold'>{language.complete.expertTitle}</span></h3>
                        </>
                    ) : (
                        <>
                            <h1 className='millionText'>{language.complete.congratulations}, {userName.toUpperCase()}!</h1>
                            <h3 className="millionText">{language.complete.youAre} <span className='millionTextBold'>{language.complete.expertTitle}</span></h3>
                        </>
                    )}
                    <button onClick={handlePlayAgain} className='main-btn'>{language.complete.playAgainButton}</button>
                </div>
            </div>
        </div>
    );
}; 